module.exports = __webpack_public_path__ + "img/picto-tab-quicksearch.fe0e3537.svg";